export default {
  fundraiseConfigurations: ({ fundraiseConfig }) => fundraiseConfig || {},
  supportedCurrencies: ({ fundraiseConfig }) => (fundraiseConfig.supportedCurrencies || []),
};
